import * as React from 'react';
import styles from './index.scss';
import { ButtonBase } from '../button-base';

export interface Props {
  id?: string;
  iconSize?: number;
  iconPadding?: number;
  style?: React.CSSProperties;
  iconStyle?: React.CSSProperties;
  iconColor?: string;
  controlBlockStyle?: React.CSSProperties;
  hideOnClick?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  onTouchStart?: (e: React.TouchEvent) => void;
}

/**
 * Use `CloseButton` to display a close button
 */
export function CloseButton({
  iconSize = 15,
  iconPadding = 4,
  id = 'close-thumbnail-control',
  iconColor = '#FFFFFF',
  onClick,
  onTouchStart,
  iconStyle = { filter: 'drop-shadow(rgba(0, 0, 0, 0.5) 0px 1px 1px)' },
  style,
  controlBlockStyle = {},
  hideOnClick = false
}: Props) {
  const [hasBeenClicked, setHasBeenClicked] = React.useState(false);

  const onClickAction = (e: React.MouseEvent) => {
    onClick && onClick(e);
    hideOnClick && setHasBeenClicked(true);
  };

  return (
    <>
      {!hasBeenClicked && (
        <ButtonBase
          id="close-btn"
          data-zone="close_button"
          aria-label="ogury_close_button"
          onTouchStart={onTouchStart}
          onClick={onClickAction}
          style={controlBlockStyle}
        >
          <div
            style={{
              height: iconSize + iconPadding * 2,
              width: iconSize + iconPadding * 2,
              padding: iconPadding,
              ...style
            }}
            className={styles.closeButton}
          >
            <svg
              id={id}
              width={iconSize}
              height={iconSize}
              viewBox="0 0 16 16"
              style={iconStyle}
            >
              <path
                d="M21,6.611,19.389,5,13,11.389,6.611,5,5,6.611,11.389,13,5,19.389,6.611,21,13,14.611,19.389,21,21,19.389,14.611,13Z"
                transform="translate(-5 -5)"
                fill={iconColor}
              />
            </svg>
          </div>
        </ButtonBase>
      )}
    </>
  );
}
